/* Playably homepage — interactivity (vanilla JS port of the prototype's React behavior).
   Safe to load once globally. Re-inits on Shopify section load/select events. */
(function () {
  function rotators(root) {
    root.querySelectorAll('.hero-rotate[data-words]').forEach(function (el) {
      if (el.__pa) return; el.__pa = true;
      var words = el.getAttribute('data-words').split('|');
      var i = 0; el.textContent = words[0];
      setInterval(function () {
        i = (i + 1) % words.length;
        el.textContent = words[i];
        el.style.animation = 'none'; void el.offsetWidth; el.style.animation = '';
      }, 2400);
    });
  }

  function stage(root) {
    root.querySelectorAll('.hiw').forEach(function (s) {
      if (s.__pa) return; s.__pa = true;
      var dots = s.querySelectorAll('.hiw-prog-dot');
      var lines = s.querySelectorAll('.hiw-prog-line');
      var panes = s.querySelectorAll('.hiw-pane');
      var copies = s.querySelectorAll('.hiw-copy');
      var tabs = s.querySelectorAll('.hiw-tab');
      var n = panes.length, active = 0, timer = null;
      function set(k) {
        active = k;
        dots.forEach(function (d, i) { d.classList.toggle('on', i === k); d.classList.toggle('past', i < k); });
        lines.forEach(function (l, i) { l.classList.toggle('fill', i < k); });
        panes.forEach(function (p, i) { p.classList.toggle('on', i === k); });
        copies.forEach(function (c, i) { c.classList.toggle('on', i === k); });
        tabs.forEach(function (t, i) { t.classList.toggle('on', i === k); });
      }
      function go(k) { set(k); restart(); }
      function restart() {
        clearInterval(timer);
        timer = setInterval(function () { set((active + 1) % n); }, 4200);
      }
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      set(0); restart();
    });
  }

  function plays(root) {
    root.querySelectorAll('.plays').forEach(function (s) {
      if (s.__pa) return; s.__pa = true;
      var items = s.querySelectorAll('.play-item');
      var pvs = s.querySelectorAll('.plays-visual .pv');
      var n = items.length, active = 0, timer = null;
      function set(k) {
        active = k;
        items.forEach(function (it, i) { it.classList.toggle('active', i === k); });
        pvs.forEach(function (p, i) { p.classList.toggle('on', i === k); });
      }
      function restart() {
        clearInterval(timer); if (n < 2) return;
        timer = setInterval(function () { set((active + 1) % n); }, 4200);
      }
      function go(k) { set(k); restart(); }
      items.forEach(function (it, i) { it.addEventListener('click', function () { go(i); }); });
      set(0); restart();
    });
  }

  function faq(root) {
    root.querySelectorAll('.faq').forEach(function (s) {
      if (s.__pa) return; s.__pa = true;
      var items = s.querySelectorAll('.faq-item');
      items.forEach(function (it, idx) {
        var q = it.querySelector('.faq-q');
        if (!q) return;
        q.addEventListener('click', function () {
          var open = it.classList.contains('open');
          items.forEach(function (o) { o.classList.remove('open'); });
          if (!open) it.classList.add('open');
        });
      });
      if (items[0]) items[0].classList.add('open');
    });
  }

  // Scroll reveal
  var reveal = (function () {
    var SEL = '.cn-art .cn-eyebrow, .cn-art h1.cn-h1, .cn-art section h2.cn-h2, .cn-art .hero-sub, .cn-art .hero-actions, .cn-art .hero-visual, .cn-art .stat-item, .cn-art .how-card, .cn-art .trig-card, .cn-art .play-item, .cn-art .plays-visual, .cn-art .quote-card, .cn-art .faq-item, .cn-art .cm-head, .cn-art .founder-photo, .cn-art .founder-copy, .cn-art .closing-inner, .cn-art .hiw-stage, .cn-art .hiw-prog, .cn-art .hiw-tabs';
    var reduceCss = false, started = false;
    function reduce() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    function tag() {
      var els = document.querySelectorAll(SEL); if (!els.length) return;
      var vh = window.innerHeight || 800; var counts = new Map();
      els.forEach(function (el) {
        if (el.__rv || el.closest('.pa-no-reveal')) return; el.__rv = true;
        el.classList.add('pa-rv');
        var r = el.getBoundingClientRect();
        if (reduce() || (r.top < vh * 0.92 && r.bottom > 0)) { el.classList.add('pa-rv-in'); return; }
        var p = el.parentElement, idx = counts.get(p) || 0;
        if (idx > 0) el.style.transitionDelay = Math.min(idx * 70, 420) + 'ms';
        counts.set(p, idx + 1);
      });
    }
    function check() {
      var vh = window.innerHeight || 800;
      document.querySelectorAll('.cn-art .pa-rv:not(.pa-rv-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < vh * 0.86) el.classList.add('pa-rv-in');
      });
    }
    function start() {
      if (started) return; started = true;
      if (!document.getElementById('pa-rv-style')) {
        var st = document.createElement('style'); st.id = 'pa-rv-style';
        st.textContent = '.cn-art .pa-rv{opacity:0;transform:translateY(28px);transition:opacity .7s cubic-bezier(.22,1,.36,1),transform .7s cubic-bezier(.22,1,.36,1);will-change:opacity,transform}.cn-art .pa-rv.pa-rv-in{opacity:1;transform:none}@media (prefers-reduced-motion: reduce){.cn-art .pa-rv{opacity:1!important;transform:none!important;transition:none!important}}';
        document.head.appendChild(st);
      }
      var ticking = false;
      function onScroll(){ if(ticking) return; ticking = true; requestAnimationFrame(function(){ ticking=false; check(); }); }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      var last = 0;
      (function loop(ts){ if(!last||ts-last>120){last=ts;tag();check();} if(document.querySelector('.cn-art .pa-rv:not(.pa-rv-in)')||!document.querySelector('.cn-art')) requestAnimationFrame(loop); })();
    }
    return { start: start };
  })();

  function init(root) {
    root = root || document;
    rotators(root); stage(root); plays(root); faq(root);
    reveal.start();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();
